<template>
  <div class="d-flex">
    <v-select
      v-model="hasInvoice"
      :items="items"
      prepend-icon="mdi-cash green--text"
      solo-inverted
      hide-details
      return-object
      dense
    />
  </div>
</template>

<script>
export default {
  computed: {
    hasInvoice: {
      get() {
        return this.$store.state.filters.hasInvoice;
      },
      set(hasInvoice) {
        this.$store.commit("setHasInvoice", hasInvoice);
      },
    },
    items() {
      return [
        { text: this.$t("all"), value: "" },
        { text: this.$t("payments.withInvoice"), value: 1 },
        { text: this.$t("payments.withoutInvoice"), value: 0 },
      ];
    },
  },
};
</script>
